import { ServiceVariation } from "@/services/backend/omni/servicevariation/types/service-variation";
import t from "@/lang/lang";
import { TableColumn } from "../position/components/positions-component";
import { PositionsTableConfig } from "../position/components/positions-table";
import { Position } from "../position/types/position";
import { PositionKind } from "../position/types/position-kind";
import {
  offerablePositionBaseData,
  PositionOptions,
} from "../position/types/position-base-data";
import { wrhPricesUsed } from "./wrh-prices-used";

/**
 * wrhPositionsTableConfig returns the configuration of a
 * {@link PositionsTable} of the positions of a WRH scope of work of serviceVariation.
 * They belong to no group or area, and a product lists its consumables as
 * priced sub-positions, see `WRHPositions`,
 * backend/core/omni/domain/servicekindrules/wrh_positions.go.
 *
 * Full-service positions are priced by subscription and show no final
 * price. Which price a position shows on documents, see
 * {@link wrhPricesUsed}, is chosen in its details dialog. Positions of any
 * other service variation show the final price once a total sums them.
 */
export function wrhPositionsTableConfig(
  serviceVariation: ServiceVariation,
  positions: Position[],
  options: PositionOptions,
): PositionsTableConfig {
  const isFullService = serviceVariation === ServiceVariation.WRHFullService;
  const showFinalPrice =
    !isFullService && positions.some((p) => p.kind === PositionKind.Total);

  return {
    groupName: t("Gebäude"),
    areaName: t("Räume"),
    addPositionOptions: offerablePositionBaseData(positions, options),
    groupings: [],
    pricesUsed: wrhPricesUsed,
    subPositionKinds: [
      PositionKind.Default,
      PositionKind.Dynamic,
      PositionKind.Text,
    ],
    tableColumns: [
      TableColumn.DnDGrip,
      TableColumn.Number,
      TableColumn.Active,
      TableColumn.Text,
      ...(isFullService ? [TableColumn.Cycle] : []),
      TableColumn.Category,
      TableColumn.Count,
      TableColumn.Unit,
      TableColumn.UnitPrice,
      ...(showFinalPrice ? [TableColumn.FinalPrice] : []),
      ...(isFullService
        ? [TableColumn.SubscriptionInterval, TableColumn.SubscriptionPrice]
        : []),
      TableColumn.Actions,
    ],
  };
}
